import molin_4 from '../../assets/images/tra/molin_4.webp';
import molin_5 from '../../assets/images/tra/molin_5.webp';
import MolinHeader from '../../components/MolinHeader';
import { useState } from 'react';
import '../../styles/common.css'
export default function RestaurantTreasurePavilion() {
    const [storyStatus, setStoryStatus] = useState(0);
    return (
        <div className="relative">
            <MolinHeader></MolinHeader>
            {storyStatus === 0 && (
                <img src={molin_4} alt="Hero background" className="w-full h-auto" />
            )}
            {storyStatus >= 1 && (
               <img src={molin_5} alt="Hero background" className="w-full h-auto" />
            )}
            <div className='absolute bottom-[18%] left-[43%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                <div className="flex flex-col text-center font-bold">
                    <span className="text-[#000000] text-[1vw]">项元汴</span>
                    <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                </div>
            </div>
            {storyStatus === 0 && (
                <div className="top-[48%] left-[59%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(1)}>
                    </button>
                </div>
            )}
            {storyStatus === 1 && (
                <div className="top-[36%] left-[46%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(2)}>
                    </button>
                </div>
            )}
            {storyStatus >= 1 && (
                <div className={`chat-bubble-base absolute top-[25%] left-[90%] transform -translate-x-1/2 chat-bubble-left 
      chat-bubble-fade-in ${storyStatus >= 1 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“项先生，近期本藏宝阁新寻得珍宝，不知您是否钟意。”</span>
                    <span className='mb-[1vw] typing-effect'>"I’ve heard of it in passing. I can go search for it for Master Xiang."</span>
                </div>
            )}
            {storyStatus >= 2 && (
                <div className={`chat-bubble-base absolute top-[30%] left-[50%] transform -translate-x-1/2 chat-bubble-right
                chat-bubble-fade-in ${storyStatus >= 2 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“此瓷不错，劳烦掌柜送到我家天籁阁。”</span>
                    <span className='mb-[1vw] typing-effect'>"This porcelain is excellent. Kindly have the master deliver it to my Tianlai Pavilion."</span>
                </div>
            )}
        </div>
    )
}